import { render, staticRenderFns } from "./mytask.vue?vue&type=template&id=3c57a886"
import script from "./mytask.vue?vue&type=script&lang=js"
export * from "./mytask.vue?vue&type=script&lang=js"
import style0 from "./mytask.vue?vue&type=style&index=0&id=3c57a886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports